/* Vendor */
/* Services */
import { Metric } from '@/services/metrics/models/Metrics'
import { Ecommerce } from '@/services/metrics/types/ecommerce.types'
import { YM } from '@/services/metrics/types/scripts.types'
/* Types */
import {
  ParamsDefault,
  ParamsEcommerce,
  ParamsPageView,
} from '@/services/metrics/types/service.types'
/* Utils */
import {
  initVendorYandexMetrics,
  injectionProvider,
} from '@/services/metrics/utils/yandex'
import vendorYandexMetric from '@/services/metrics/vendor/yandex-metrika'

const TYPE_EVENT = 'reachGoal'
const EVENT_INIT = 'init'
const EVENT_HIT = 'hit'

export class YandexMetric extends Metric {
  // Обзначаем, что поле будет инициализировано позже
  #provider!: YM

  async initVendor() {
    await initVendorYandexMetrics(vendorYandexMetric)

    window.dataLayer = []

    this.#provider = {
      main: injectionProvider(this.ids.mainId),
      city: injectionProvider(this.ids.cityId),
      dataLayer: window.dataLayer,
    }

    // Инициализация общего счетчика
    this.ids.mainId && this.setParamsMetric(this.ids.mainId, true)

    // Инициализация счетчика города
    this.ids.cityId && this.setParamsMetric(this.ids.cityId, false)
  }

  private setParamsMetric(id: string, webvisor: boolean) {
    window?.ym(id, EVENT_INIT, {
      id,
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor,
      ecommerce: 'dataLayer',
    })
  }

  eventSendGoal({ ym }: ParamsDefault) {
    if (!ym) return

    this.#provider.main(TYPE_EVENT, ym)
    this.#provider.city(TYPE_EVENT, ym)
  }

  eventPageView({ ym }: ParamsPageView) {
    if (!this.ids.cityId || !ym) return

    const urlTo = `${origin}${ym.to.fullPath}`
    const urlFrom = `${origin}${ym.from.fullPath}`

    this.#provider.city(this.ids.cityId, EVENT_HIT, urlTo, {
      referer: urlFrom,
    })
  }

  sendEcommerce(ym?: Ecommerce) {
    if (!ym) return

    this.#provider.dataLayer.push(ym)
  }

  eventViewedProduct({ ym }: ParamsEcommerce) {
    this.sendEcommerce(ym)
  }

  eventAddProduct({ ym }: ParamsEcommerce) {
    this.sendEcommerce(ym)
  }

  eventPurchase({ ym }: ParamsEcommerce) {
    this.sendEcommerce(ym)
  }
}
